import { FitLevel } from 'interfaces';
import { computed } from 'vue';
import Widget from '../Widget/Widget';

export default class ButtonIcon extends Widget {
	private blueBackground = computed((): boolean => {
		if (
			this.bestFitScore.value !== null &&
			this.fitText.value as FitLevel !== FitLevel.BETTER_OPTIONS_AVAILABLE &&
			this.isFullProfile
		) {
			return true;
		}
		if (this.hasEmptyText.value && this.bestFitScore.value === null) {
			return true;
		}

		return false;
	});

	private greyText = computed((): boolean => {
		if (
			this.bestFitScore.value !== null &&
			this.fitText.value as FitLevel === FitLevel.BETTER_OPTIONS_AVAILABLE &&
			this.isFullProfile.value
		) {
			return true;
		}

		return false;
	});

	private fitText = computed((): string => {
		if (this.isFullProfile.value && this.bestFitScore.value) {
			return `${this.displayScore.value}`;
		}
		if (this.emptyText !== null) {
			return this.emptyText;
		}

		return '';
	});
}
